import React from 'react';
import CompliancePage from '../components/CompliancePage';
import { COMPLIANCE_PAGES } from '../config';

const TermsOfServicePage = () => {
  return <CompliancePage pageData={COMPLIANCE_PAGES.termsOfService} />;
};

export default TermsOfServicePage;
